import { EmloyeesGroup } from "types";
import { useEmployeesState } from "atoms/employeesAtom";
import { useGetEmployeesGroups } from "shared-apis";
import { useSetAtom } from "jotai/index";

import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";

import { setEmployeesGroupModalAtom } from "../../../atoms/modalAtom/modalAtom";

import styles from "../styles.module.scss";

export const EmployeesGroupList = (): JSX.Element => {
  const { employeesState, setEmployeesState } = useEmployeesState();
  const { data: employeesGroups = [] } = useGetEmployeesGroups();
  const setEmployeesGroupModal = useSetAtom(setEmployeesGroupModalAtom);

  const handleClick = (groupItem: EmloyeesGroup | null) => {
    if (
      groupItem?.item.usersgroupid &&
      groupItem?.item.usersgroupid ===
        employeesState.activeGroupItem?.item.usersgroupid
    ) {
      setEmployeesGroupModal(true);
    } else {
      setEmployeesState((prev) => ({ ...prev, activeGroupItem: groupItem }));
    }
  };

  return (
    <div className={styles.container}>
      <Row
        onClick={() => handleClick(null)}
        isActive={employeesState.activeGroupItem === null}
      >
        <Paragraph>Все</Paragraph>
      </Row>

      {employeesGroups?.map((group: EmloyeesGroup) => (
        <Row
          key={group.item.usersgroupid}
          onClick={() => handleClick(group)}
          isActive={
            employeesState.activeGroupItem?.item?.usersgroupid ===
            group.item.usersgroupid
          }
        >
          <Paragraph>{group.item.name}</Paragraph>
        </Row>
      ))}
    </div>
  );
};
